module.exports = __webpack_public_path__ + "static/path-39dae1d31bc8f5d6b5cd0233c1688ea1.jpg";